function initHeader() {
  // Stop if URL contains /wishlist or /a/search
  if (window.location.pathname.includes('/wishlist')) return;
  if (window.location.pathname.includes('/a/search')) return;

  const header = document.querySelector('#aoc-header') || document.querySelector('header');
  const mainContent = document.querySelector('#MainContent');

  if (!header) return;

  // Set CSS variable
  function setHeaderHeight() {
    requestAnimationFrame(() => {
      const height = header.getBoundingClientRect().height;

      if (height > 0) {
        document.documentElement.style.setProperty(
          '--header-height',
          `${height}px`
        );
      }
    });
  }

  // Toggle transparency on scroll
  function handleScroll() {
    header.classList.toggle('is_transparent', window.scrollY <= 100);
  }

  // Add class once only
  if (mainContent) {
    mainContent.classList.add('has-transparent-header');
  }

  // Initial scroll state
  handleScroll();

  // Wait until everything is rendered
  window.addEventListener('load', setHeaderHeight);

  // Recalculate on resize
  window.addEventListener('resize', setHeaderHeight);

  // Update transparency on scroll
  window.addEventListener('scroll', handleScroll, { passive: true });

  // Observe header size changes (great for iOS + Shopify)
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(setHeaderHeight);
    observer.observe(header);
  }

  // Fallback extra check
  setTimeout(setHeaderHeight, 300);
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeader);
} else {
  initHeader();
}